import { buildTenantHost, parseCotenHostname } from "./host";

export function buildTenantRootUrl(params: { tenantShortCode: string; href: string }): URL | undefined {
  const url = new URL(params.href);
  const parsedHost = parseCotenHostname(url.hostname);
  if (!parsedHost.app || !parsedHost.tld) return;

  url.hostname = buildTenantHost({
    tenantShortCode: params.tenantShortCode,
    app: parsedHost.app,
    tld: parsedHost.tld,
  });
  url.pathname = "/";
  url.search = "";
  url.hash = "";
  return url;
}
